// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file reports/fast_moving_items_report.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { MovingItemsItem } from "./common_pb.js";

/**
 * @generated from message com.neulink.pharmacy.FastMovingItemsReportRequest
 */
export class FastMovingItemsReportRequest extends Message<FastMovingItemsReportRequest> {
  /**
   * Page number for pagination
   *
   * @generated from field: int32 page_number = 1;
   */
  pageNumber = 0;

  /**
   * Number of records per page
   *
   * @generated from field: int32 page_size = 2;
   */
  pageSize = 0;

  constructor(data?: PartialMessage<FastMovingItemsReportRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.FastMovingItemsReportRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "page_number", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "page_size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FastMovingItemsReportRequest {
    return new FastMovingItemsReportRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FastMovingItemsReportRequest {
    return new FastMovingItemsReportRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FastMovingItemsReportRequest {
    return new FastMovingItemsReportRequest().fromJsonString(jsonString, options);
  }

  static equals(a: FastMovingItemsReportRequest | PlainMessage<FastMovingItemsReportRequest> | undefined, b: FastMovingItemsReportRequest | PlainMessage<FastMovingItemsReportRequest> | undefined): boolean {
    return proto3.util.equals(FastMovingItemsReportRequest, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.FastMovingItemsReportResponse
 */
export class FastMovingItemsReportResponse extends Message<FastMovingItemsReportResponse> {
  /**
   * List of fast moving items
   *
   * @generated from field: repeated com.neulink.pharmacy.MovingItemsItem fast_moving_items = 1;
   */
  fastMovingItems: MovingItemsItem[] = [];

  /**
   * Total number of items available
   *
   * @generated from field: int32 total_count = 2;
   */
  totalCount = 0;

  constructor(data?: PartialMessage<FastMovingItemsReportResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.FastMovingItemsReportResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "fast_moving_items", kind: "message", T: MovingItemsItem, repeated: true },
    { no: 2, name: "total_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FastMovingItemsReportResponse {
    return new FastMovingItemsReportResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FastMovingItemsReportResponse {
    return new FastMovingItemsReportResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FastMovingItemsReportResponse {
    return new FastMovingItemsReportResponse().fromJsonString(jsonString, options);
  }

  static equals(a: FastMovingItemsReportResponse | PlainMessage<FastMovingItemsReportResponse> | undefined, b: FastMovingItemsReportResponse | PlainMessage<FastMovingItemsReportResponse> | undefined): boolean {
    return proto3.util.equals(FastMovingItemsReportResponse, a, b);
  }
}

